import {
  ActionReducerMap } from '@ngrx/store';
import { routerReducer, RouterReducerState } from '@ngrx/router-store';

import { JourneyNavigationState, reducer as journeyNavigationReducer } from './journey-navigation.reducer';
import { PolicyState, reducer as loadPolicyReducer } from './policy.reducer';
import { StpState, reducer as stpReducer } from './stp.reducer';


export interface State {
  router: RouterReducerState;
  journeyNavigationState: JourneyNavigationState;
  policyState: PolicyState;
  stpState: StpState;
}

export const reducers: ActionReducerMap<State> = {
  router: routerReducer,
  journeyNavigationState: journeyNavigationReducer,
  policyState: loadPolicyReducer,
  stpState: stpReducer
};



